import { api } from './client';

// AI API
export const aiApi = {
  summarize: (params: { taskId: string }) => api.post<{ summary: string }>('/ai/summarize', params),

  generateSubtasks: (params: { taskTitle: string; taskDescription?: string }) =>
    api.post<{ subtasks: string[] }>('/ai/subtasks', params),

  rewrite: (params: { text: string; tone: 'professional' | 'concise' | 'friendly' }) =>
    api.post<{ rewritten: string }>('/ai/rewrite', params),
};
